import React from 'react';
import { Quote, Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Carlos Mendes',
      role: 'CEO, TechFlow Solutions',
      image: null,
      rating: 3,
      text: 'O site institucional desenvolvido pela System superou todas as expectativas. Além do design impecável, conseguimos aumentar em 340% as solicitações de orçamento. O investimento se pagou em menos de 2 meses.'
    },
    {
      name: 'Marina Silva',
      role: 'Fundadora, Estilo Arquitetura',
      image: null,
      rating: 4,
      text: 'Trabalho profissional de altíssimo nível. A landing page não apenas ficou linda, mas realmente converte. Estou fechando contratos que antes eram impossíveis. O suporte é excepcional!'
    },
    {
      name: 'Roberto Almeida',
      role: 'Diretor, Prime Imóveis',
      image: null,
      rating: 5,
      text: 'A diferença entre ter um site comum e um site profissional é gigantesca. Meus clientes percebem a qualidade imediatamente. Vale cada centavo investido. Recomendo de olhos fechados!'
    },
    {
      name: 'Juliana Costa',
      role: 'Sócia, BeautyLux',
      image: null,
      rating: 4,
      text: 'Contratar a System foi a melhor decisão que tomei para meu negócio. O site transmite exatamente a exclusividade que eu queria. As vendas online triplicaram no primeiro mês!'
    },
    {
      name: 'Fernando Santos',
      role: 'Consultor Empresarial',
      image: null,
      rating: 3,
      text: 'Profissionalismo e comprometimento do início ao fim. Entreguei meu projeto e recebi uma verdadeira obra de arte digital. Todos os meus clientes elogiam meu site. Excelente retorno sobre investimento.'
    },
    {
      name: 'Patricia Oliveira',
      role: 'Proprietária, Elite Clínica',
      image: null,
      rating: 5,
      text: 'Site rápido, bonito e funcional. O pacote de manutenção é incrível - nunca preciso me preocupar com nada técnico. Foco no meu negócio enquanto o site trabalha para mim 24/7.'
    }
  ];

  return (
    <section id="depoimentos" style={{
      padding: '120px 40px',
      background: 'linear-gradient(180deg, #000000 0%, #0a0a0a 100%)'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div className="fade-in" style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title">
            O Que Dizem Nossos <span className="gold-gradient">Clientes</span>
          </h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Resultados reais de clientes reais. Cada depoimento representa um negócio
            transformado pela excelência digital.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          {testimonials.map((testimonial, idx) => (
            <div
              key={idx}
              className="fade-in"
              style={{
                background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.05) 0%, transparent 100%)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                borderRadius: '12px',
                padding: '40px',
                position: 'relative',
                transition: 'transform 0.3s ease, border-color 0.3s ease',
                transitionDelay: `${idx * 0.1}s`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
              }}
            >
              {/* Quote icon */}
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                opacity: 0.1
              }}>
                <Quote size={60} color="#D4AF37" />
              </div>

              {/* Rating */}
              <div style={{
                display: 'flex',
                gap: '5px',
                marginBottom: '20px'
              }}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="#D4AF37" color="#D4AF37" />
                ))}
              </div>

              {/* Testimonial text */}
              <p style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '15px',
                fontWeight: '300',
                color: '#FFFFFF',
                lineHeight: '1.8',
                marginBottom: '30px',
                position: 'relative',
                zIndex: 1
              }}>
                "{testimonial.text}"
              </p>

              {/* Client info */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(212, 175, 55, 0.2)'
              }}>
                {/* Avatar placeholder */}
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.3) 0%, rgba(212, 175, 55, 0.1) 100%)',
                  border: '2px solid rgba(212, 175, 55, 0.5)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#D4AF37'
                }}>
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <div style={{
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#FFFFFF',
                    marginBottom: '5px'
                  }}>
                    {testimonial.name}
                  </div>
                  <div style={{
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '13px',
                    fontWeight: '400',
                    color: '#CCCCCC'
                  }}>
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="fade-in" style={{
          marginTop: '80px',
          textAlign: 'center',
          padding: '50px',
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, transparent 100%)',
          border: '1px solid rgba(212, 175, 55, 0.3)',
          borderRadius: '12px',
          transitionDelay: '0.8s'
        }}>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '18px',
            fontWeight: '300',
            color: '#CCCCCC',
            marginBottom: '20px'
          }}>
            Junte-se a dezenas de empreendedores que já transformaram seus negócios
          </p>
          <div style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '36px',
            fontWeight: '700',
            color: '#D4AF37'
          }}>
            100% de Satisfação Garantida
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #depoimentos > div > div:nth-child(2) {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Testimonials;